module.exports = __webpack_public_path__ + "img/T-360_leader_First_Frame.a992bfb0.png";